<template>
  <v-container>
    <v-progress-linear indeterminate :active="loading"></v-progress-linear>

    <calendar-view v-model="calendar" :scheduleParams="scheduleParams"/>
  </v-container>
</template>

<script>
import CalendarView from '@/components/calendars/CalendarView';

export default {
  data: () => ({
    calendar: null,
    loading: false,
    scheduleParams: null,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
    calendarId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getCalendar();

    const { query } = this.$route;

    if (!query || query.constructor !== Object || Object.entries(query).length === 0) {
      return;
    }

    if ('q' in query && query.q.length > 0) {
      this.scheduleParams = JSON.parse(atob(query.q));
    }
  },
  methods: {
    getCalendar() {
      this.loading = true;
      this.$store
        .dispatch('calendars/get', this.calendarId)
        .then((calendar) => {
          this.calendar = calendar;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  components: {
    CalendarView,
  },
};
</script>
